import React, { useCallback, useEffect } from 'react'

import { useAnonymousUserData } from '../../data/use-anonymous-user-data'
import { useOpenUrl } from '../../hooks/use-open-url'
import { validateB2BToken } from '../../lib/b2b-company'
import { RootStackScreenProps } from '../../navigation'

type Props = RootStackScreenProps<'LandingPageRedirect'>

export const LandingPageRedirect: React.FC<Props> = ({ navigation, route }) => {
  const { openUrl } = useOpenUrl()
  const { setAnonymousUserData } = useAnonymousUserData()
  const { companySlug, token } = route.params

  const redirectToWelcome = useCallback(() => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'Welcome' }],
    })
  }, [])

  useEffect(() => {
    validateB2BToken({ companySlug, token })
      .then(async ({ data, error }) => {
        if (error) {
          redirectToWelcome()
        }

        if (!data?.isTokenVerified) {
          if (data?.redirectUrl) {
            openUrl(data.redirectUrl)
          }
          return redirectToWelcome()
        } else {
          setAnonymousUserData({
            data: {
              firstName: data.firstName,
              lastName: data.lastName,
              email: data.email,
              companySlug,
              landingPageToken: token,
            },
          })
          redirectToWelcome()
        }
      })
      .catch(() => {
        redirectToWelcome()
      })
  }, [])

  return <></>
}
